import * as React from "react";
import { styled } from "@mui/system";
import MUICssBaseline from "@mui/material/CssBaseline";
import { CssBaselineProps as CssBaselinePropsMUI } from "@mui/material/CssBaseline";
export interface CssBaselineProps extends CssBaselinePropsMUI {}

export const CssBaseline = styled(MUICssBaseline, {
  name: "CssBaseline",
  slot: "Root",
  overridesResolver: (props, styles) => []
})(({ theme }) => ({}));
